import React from 'react';
import { Navigate } from 'react-router-dom';
import styled from 'styled-components';

const FooterWrap = styled.div`
  width: 100%;

`;

const FooterContainer = styled.div`
  border-top-right-radius:50px;
  border-top-left-radius:50px;
  box-shadow: 0 -2px 4px rgba(0, 0, 0, 0.1);
  max-width:1540px;
  background-color: #F7F7F7;
  margin: 0 auto;
  padding: 20px 0px;
  text-align: center; /* Center align text */
`;

const FooterCenter = styled.div`
  text-align: center; /* Center align text */
`;

const CompanyInfo = styled.div`
  margin-bottom: 20px;
`;

const InfoList = styled.ul`
  display: flex;
  flex-wrap: wrap;
  list-style: none;
  padding: 0;
  margin: 0;
  justify-content: center; /* Center align list items */
`;

const InfoItem = styled.li`
  margin-right: 15px;
  font-size: 14px;
`;

const CompanyDetails = styled.div`
  font-size: 12px;
  color: #666;
  line-height: 1.5;
`;

export default function Footer ({ isFixed }) {
  return (
    <FooterWrap style={{ position: isFixed ? 'fixed' : 'relative', bottom: isFixed ? '0' : 'auto' }}>
      <FooterContainer>
        <FooterCenter>
          <CompanyInfo>
            <InfoList>
              <InfoItem onClick={()=>Navigate('/CSCenter/Support')}>이용약관 l </InfoItem>
              <InfoItem onClick={()=>Navigate('/CSCenter/Support')}>개인정보취급방침 l </InfoItem>
              <InfoItem onClick={()=>Navigate('/CSCenter/Support')}>청소년보호정책 l </InfoItem>
              <InfoItem onClick={()=>Navigate('/CSCenter/Support')}>구매문의</InfoItem>
            </InfoList>
            <CompanyDetails>
              <p>
                사이트명 : 씨네체인 &nbsp;&nbsp;&nbsp;&nbsp; 상호 : (주) 언체인 &nbsp;&nbsp;&nbsp;&nbsp; 대표자명 : 박준영 &nbsp;&nbsp;&nbsp;&nbsp; 개인정보관리책임자 : 박준영
                <br />
                사업자등록번호 : 523-81-03358 &nbsp;&nbsp;&nbsp;&nbsp; 통신판매업신고번호 : 제 2000-경기남양주-0000 호 &nbsp;&nbsp;&nbsp;&nbsp; 고객센터 : 0000-0000
                <br />
                사업장주소 : 경기도 남양주시 순화궁로 249, M동 13층 1330호(별내동, 별내역파라곤스퀘어)
              </p>
            </CompanyDetails>
          </CompanyInfo>
        </FooterCenter>
      </FooterContainer>
    </FooterWrap>
  );
};

